import script from "./ChatFilePreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatFilePreview.vue?vue&type=script&setup=true&lang=ts"

import "./ChatFilePreview.vue?vue&type=style&index=0&id=8a09d784&lang=scss&scoped=true"

import exportComponent from "/var/www/briskly/brskl/products/business/app.prod.new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a09d784"]])

export default __exports__